// extracted by mini-css-extract-plugin
export default {"poweredByStripeText":"powered-by-stripe-text_poweredByStripeText__AiBbp"};